<div class="user-profile-dropdown">
    <a class="main-link" href="javascript:void(0)" (click)="toggleDropdown($event)">
        <div class="user-img-mobile-wrapper d-sm-none d-block">
            @if (isAuthenticated && profil?.profile_picture) {
                <div class="user-img-mobile"
                    [style.backgroundImage]="'url(' + profil.profile_picture + ')'">
                </div>
            } @else {
                <span class="material-icons">person</span>
            }
            @if (isAuthenticated && isStar && unreadRequestsCount > 0) {
                <span class="count-badge count-badge-mobile">{{ unreadRequestsCount }}</span>
            }
        </div>
        <div class="media d-none d-sm-flex">
            <div class="user-img"
                [style.backgroundImage]="'url(' + (isAuthenticated && profil?.profile_picture ? profil.profile_picture : 'assets/images/avatar.jpeg') + ')'">
                <img [src]="isAuthenticated && profil?.profile_picture ? profil.profile_picture : 'assets/images/avatar.jpeg'"
                    class="img-fluid bg-img" alt="user" style="display: none;">
                <span class="available-stats online"></span>
            </div>
            <div class="media-body d-none d-md-block">
                <h4>
                    @if(isAuthenticated){
                        {{ profil?.scene_name ?? profil?.prenom }}
                    }@else{
                        Se connecter
                    }
                </h4>
                <span>
                    @if(isAuthenticated){
                        en ligne
                    }
                </span>
            </div>
        </div>
    </a>
    <div class="dropdown-menu dropdown-menu-right" [class.show]="isOpen" (clickOutside)="outSideClose()">
        <div class="dropdown-header">
            <span>Mon Profil</span>
            <div class="mobile-close" (click)="isOpen = false">
                <h5>Fermer</h5>
            </div>
        </div>
        <div class="dropdown-content">
            <ul class="friend-list" *ngIf="isAuthenticated">
                <li>
                    <a [routerLink]="['/profile/timeline']" (click)="onDropdownLinkClick()">
                        <div class="media">
                            <span class="material-icons">person</span>
                            <div class="media-body">
                                <div>
                                    <h5 class="mt-0">Profil</h5>
                                    <h6>Aperçu et paramètres du profil</h6>
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
                <!-- <li>
                    <a [routerLink]="['/privacy-policy']" (click)="onDropdownLinkClick()">
                        <div class="media">
                            <app-feather-icon [icons]="'settings'"></app-feather-icon>
                            <div class="media-body">
                                <div>
                                    <h5 class="mt-0">réglage et confidentialité</h5>
                                    <h6>Les paramètres et confidentialité</h6>
                                </div>
                            </div>
                        </div>
                    </a>
                </li> -->
                <li>
                    <a (click)="logOut()">
                        <div class="media">
                            <span class="material-icons">logout</span>

                            <div class="media-body">
                                <div>
                                    <h5 class="mt-0">Se déconnecter</h5>
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>

            <ul class="friend-list" *ngIf="!isAuthenticated">
                <li>
                    <a [routerLink]="['/auth/login']">
                        <div class="media">
                            <span class="material-icons">login</span>

                            <div class="media-body">
                                <div>
                                    <h5 class="mt-0">Se connecter</h5>
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>